import React, { useCallback } from 'react';
import { Field, useForm } from 'react-final-form';
import PropTypes from 'prop-types';
import RichEditor from 'components/RichEditor';
import fieldRenderProps from 'components/FinalForm/fieldRenderProps';
import getErrorProperties from 'components/FinalForm/getErrorProperties';
import { isEqualIgnoringRewrites, rememberRewrite } from 'components/FinalForm/richEditorRewrites';

const RichEditorProxy = ({ input: { onChange, ...input }, meta, onEditorChange, ...rest }) => {

  const { batch } = useForm();

  const errorProps = getErrorProperties(meta);

  const combinedOnChange = useCallback(content => {
    batch(() => {
      onChange(content);
      onEditorChange?.(content);
    });
  }, [batch, onChange, onEditorChange]);

  return (
    <RichEditor onChange={combinedOnChange} {...input} {...errorProps} {...rest} />
  );
};

RichEditorProxy.propTypes = {
  ...fieldRenderProps,
  toggleRich: PropTypes.func,
};

const RichEditorField = ({ init, ...args }) => {

  const editorInit = {
    ...init,
    setup: (editor) => {
      let loadedContent;
      editor.on('BeforeSetContent', (event) => {
        loadedContent = !event.selection && event.format !== 'raw' && typeof event.content === 'string' ? event.content : undefined;
      });
      editor.on('SetContent', () => {
        if (loadedContent !== undefined) {
          rememberRewrite(loadedContent, editor.getContent());
        }
      });

      init?.setup?.(editor);
    },
  };

  return <Field component={RichEditorProxy} fullWidth parse={v => v} isEqual={isEqualIgnoringRewrites} init={editorInit} {...args} />;
};

RichEditorField.propTypes = {
  init: PropTypes.object,
};

export default RichEditorField;
